import {
  initialState,
  Actions,
  State,
  GET_ONE_QUIZ,
  GET_ONE_QUIZ_SUCCESS,
  GET_ONE_QUIZ_ERROR,
  RESET_GET_ONE_QUIZ,
} from "../../types/quiz/get-one.dto";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ONE_QUIZ:
      return {
        ...state,
        states: {
          loading: true,
          success: false,
          error: false,
        },
      };
    case GET_ONE_QUIZ_SUCCESS:
      return {
        ...state,
        data: JSON.parse(JSON.stringify(action.payload)),
        states: {
          loading: false,
          success: true,
          error: false,
        },
      };
    case GET_ONE_QUIZ_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          success: false,
          error: action.payload,
        },
      };
    case RESET_GET_ONE_QUIZ:
      return {
        ...initialState
      }
    default:
      return { ...state };
  }
};

export default reducers;
